export const languages = ['en', 'pl']

export const DICT = {
    en: {
        navbarAbout: "About",
        navbarSkills: "Skills",
        navbarExperience: "Experience",
        navbarProjects: "Projects",
        navbarContact: "Contact",
        navbarFullName: "Aleksandra Wilczynska",

        introHello: "Hello, my name is",
        introHelloMobile: "Hello, my name is",
        introName: "Aleksandra Wilczynska",
        introFirstName: "Aleksandra ",
        introSurName: " Wilczynska",
        introDescTopOne: "I'm a ",
        introDescTopTwo: "Front-end Developer ",
        introDescTopTree: "based in Gdynia, Poland.",
        // introDescAdd: "As a programmer, I design appealing and functional web applications. I am passionate about website design and enjoy taking on new challenges.",
        introDescAdd: "As a programmer driven by curiosity and a desire to create useful things, I enjoy growing and designing applications that make people's lives easier. I am full of enthusiasm and I derive satisfaction from new challenges.",
        introBtn: "Check out my projects",

        aboutDescElOne: "I enjoy learning new technologies and skills, and approach challenges with ",
        aboutDescElColorTwo: "a lot of energy",
        aboutDescElTree: " and ",
        aboutDescElColorFour: "dedication ",
        aboutDescElFive: "so that I achieve set goals. My ",
        aboutDescElColorSix: "commitment ",
        aboutDescElSeven: "and ",
        aboutDescElColorEight: "positive attitude ",
        aboutDescElNine: "make me valuable employee as well as a great team player ready to work in a tandem with others.",
        aboutDescElSix: "My strong points are:",
        aboutAttributeOne: "Professionalism",
        aboutAttributeTwo: "Good work organization",
        aboutAttributeThree: "20 years of work in an international team",
        aboutAttributeFour: "Commitment and creativity",
        aboutAttributeFive: "Higher education",
        aboutAttributeSix: "Experience in communicating in English",

        skills_html: "HTML5",
        skills_css: "CSS3",
        skills_js: "JavaScript",
        skills_react: "React",
        skills_redux: "Redux Toolkit",
        skills_git: "GIT Version Control",
        skills_astro: "Astro",
        skills_ts: "TypeScript",

        experiencePositionPublicis: "FRONT-END DEVELOPER",
        experienceDutiesPublicis: ["development of web applications for a renowned client in the pharmaceutical industry", "improving new functionalities and automation tools", "preparing technical documentation"],
        experienceDatesPublicis: "11/2023 - present",

        experiencePositionStudioWww: "FRONT-END DEVELOPER",
        experienceDutiesStudioWww: ["creating and developing web applications for a client in the banking industry", "user-friendly websites implementation"],
        experienceDatesStudioWww: "06/2022 - 10/2023",

        experienceCompanySea: "Sea Transport",
        experiencePositionSea: "IMPORT CUSTOMER SERVICE SPECIALIST / MANAGER",
        experienceDutiesSea: ["handling imports in sea transport", "operational support for the international carriers", "customer service for domestic and foreign clients", "organization and coordination of the team's work"],
        experienceDatesSea: "06/2004 - 10/2022",

        projectsFeaturedProject: "FEATURED PROJECT",

        projectsProjectTitleSW: "Star Wars Fans",
        projectsProjectDescSW: "A website about the Star Wars universe that is a collection of information about characters, planets, and films, which will satisfy the appetite of every fan of the saga. This site is the perfect place for anyone who loves this iconic film series and wants to delve deeper into its world.",

        projectsProjectTitleMW: "My Weather",
        projectsProjectDescMW: "A web application that shows the weather forecast using front-end technologies. By using a weather API, the user can receive current data about the weather in a specific location around the world. The interactive, visually appealing and intuitive interface allows for easy browsing of the weather forecast even for several days in advance, making the application a useful and practical tool for everyday use.",

        projectsProjectTitleStudioWWW: "Studio-www",
        projectsProjectDescStudioWWW: "A website of a company that creates web applications distinguished by its modern and aesthetic design, which encourages users to explore the site. It is an excellent tool for presenting the team's skills and portfolio of projects. The website is easy to navigate, responsive, and adapted to various mobile devices, allowing users to enjoy a seamless browsing experience on any device.",

        projectsProjectTitleBeautyS: "Beauty Studio",
        projectsProjectDescBeautyS: "A website of a beauty salon that is a business card of the company, but also an important tool for acquiring customers. It is clear and responsive, and presents the salon's services in an attractive and enticing way that encourages potential customers to use the services.",

        projectsProjectTitleTatarczuk: "Tatarczuk Services",
        projectsProjectDescTatarczuk: "A website of a company that provides hydraulic services and service of heating boilers. It presents the company's offer in a transparent and harmonious way. It reflects professionalism and commitment to the services provided, which can increase the trust of potential customers in the company.",

        projectsProjectTitleKetoZocha: "KetoZocha Blog",
        projectsProjectDescKetoZocha: "A blog featuring ketogenic diet recipes that serves as a valuable source of information for people interested in this type of diet. The website not only contains delicious and diverse recipes but also information about the ketogenic diet and its health benefits, as well as articles with tips. As a result, readers have access to valuable information that can help them maintain their health and physical condition.",

        projectsProjectTitleGoPlaces: "Go Places",
        projectsProjectDescGoPlaces: "A web application aimed at facilitating the planning and comparison of prices in various locations around the world. Thanks to its intuitive interface and additional tools, it enables a quick analysis and comparison of the cost of living during travels, even in the most distant destinations. Useful for every enthusiast of exploring new places, getting to know different cultures, and discovering the world!",

        contactFormTitle: "Write to me!",
        contactFormUserNameInputPlaceholder: "Your Name",
        contactFormUserEmailInputPlaceholder: "Your email address",
        contactFormUserMessageInputPlaceholder: "Your message",
        contactFormSendBtn: "Send",
        contactSentMessageFromPage: "Your Message has been sent!",
        contactNameInvalid: "Please enter the correct details",
        contactEmailInvalid: "Email is invalid",
        contactMessageInvalid: "Your message must contain at least 5 characters",

        greetingsStart: "Have a nice ",
        greetingsDay: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        greetingsEnd: "!",

    },

    pl: {
        navbarAbout: "O mnie",
        navbarSkills: "Umiejętności",
        navbarExperience: "Doświadczenie",
        navbarProjects: "Projekty",
        navbarContact: "Kontakt",
        navbarFullName: "Aleksandra Wilczyńska",


        introHello: "Hej, nazywam się",
        introHelloMobile: "Hej, mam na imię",
        introName: "Aleksandra Wilczyńska",
        introFirstName: "Aleksandra ",
        introSurName: "Wilczyńska",
        introDescTopOne: "Jestem ",
        introDescTopTwo: "Front-end Developerem ",
        introDescTopTree: "z Gdyni.",

        // introDescAdd: "Jako programistka na co dzień zajmuję się projektowaniem estetycznych i funkcjonalnych aplikacji webowych. Jestem pełna zapału i czerpię satysfakcję z nowych wyzwań.",
        introDescAdd: "Jako programistka, którą napędza ciekawość i chęć tworzenia rzeczy użytecznych, lubię się rozwijać i projektować aplikacje, które ułatwiają ludziom życie. Jestem pełna zapału i czerpię satysfakcję z nowych wyzwań.",
        introBtn: "Sprawdź moje projekty",

        aboutDescElOne: "Lubię rozwijać swoje umiejętności i poznawać nowe technologie, a ",
        aboutDescElColorTwo: "wrodzona determinacja ",
        aboutDescElTree: "i ",
        aboutDescElColorFour: "skrupulatność ",
        aboutDescElFive: "pozwala mi osiągać wyznaczone cele. Moje ",
        aboutDescElColorSix: "zaangażowanie ",
        aboutDescElSeven: "i ",
        aboutDescElColorEight: "pozytywne nastawienie do pracy ",
        aboutDescElNine: "sprawiają, że jestem nie tylko wartościowym pracownikiem, ale także dobrym działaczem zespołowym, gotowym do współpracy w celu osiągnięcia sukcesu.",
        aboutDescElSix: "Moje mocne strony to: ",
        aboutAttributeOne: "Profesjonalizm",
        aboutAttributeTwo: "Dobra organizacja pracy",
        aboutAttributeThree: "20 lat pracy w międzynarodowym zespole",
        aboutAttributeFour: "Zaangażowanie i kreatywność",
        aboutAttributeFive: "Wyższe wykształcenie",
        aboutAttributeSix: "Doświadczenie w komunikacji w języku angielskim",

        skills_html: "HTML5",
        skills_css: "CSS3",
        skills_js: "JavaScript",
        skills_react: "React",
        skills_redux: "Redux Toolkit",
        skills_git: "GIT Version Control",
        skills_astro: "Astro",
        skills_ts: "TypeScript",

        experiencePositionPublicis: "FRONT-END DEVELOPER",
        experienceDutiesPublicis: ["tworzenie aplikacji webowych dla renomowanego klienta z branży farmaceutycznej", "rozwijanie nowych funkcjonalności i automatyzacja", "opracowywanie dokumentacji technicznej"],
        experienceDatesPublicis: "11/2023 - obecnie",

        experiencePositionStudioWww: "FRONT-END DEVELOPER",
        experienceDutiesStudioWww: ["tworzenie i rozwijanie aplikacji webowych dla klienta z branży bankowości elektronicznej", "implementacja stron internetowych"],
        experienceDatesStudioWww: "06/2022 - 10/2023",

        experienceCompanySea: "Transport Morski",
        experiencePositionSea: "SPECJALISTA DS. IMPORTU / KIEROWNIK DZIAŁU",
        experienceDutiesSea: ["realizacja importu w transporcie morskim", "wsparcie operacyjne armatorów zagranicznych", "współpraca z klientami krajowymi i zagranicznymi", "organizacja oraz koordynacja pracy zespołu"],
        experienceDatesSea: "06/2004 - 10/2022",

        projectsFeaturedProject: "WYKONANY PROJEKT",

        projectsProjectTitleSW: "Star Wars Fans",
        projectsProjectDescSW: "Strona internetowa o universum Gwiezdnych Wojen będąca zbiorem informacji o postaciach, planetach i filmach, który zaspokoi apetyt każdego fana sagi. Strona ta to doskonałe miejsce dla wszystkich, którzy kochają tę kultową serię filmową i chcą zgłębić jej świat.",

        projectsProjectTitleMW: "My Weather",
        projectsProjectDescMW: "Aplikacja webowa pokazująca prognozę pogody przy wykorzystaniu technologii front-endowych. Dzięki użyciu API pogodowego, użytkownik może otrzymać bieżące dane na temat pogody w danym miejscu na świecie. Interaktywny i gustowny interfejs pozwala na łatwe przeglądanie prognozy pogody na kilka dni do przodu, co czyni z aplikacji przydane i użyteczne narzędzie codziennego użytku.",

        projectsProjectTitleStudioWWW: "Studio-www",
        projectsProjectDescStudioWWW: "Strona internetowa firmy tworzącej aplikacje webowe wyróżniająca się nowoczesnym i estetycznym designem, który zachęca do eksplorowania witryny. To doskonałe narzędzie do prezentacji umiejętności zespołu oraz portfolia projektów. Strona jest łatwa w nawigacji, responsywna oraz dostosowana do różnych urządzeń mobilnych, dzięki czemu użytkownicy mogą komfortowo przeglądać treści na dowolnym urządzeniu.",

        projectsProjectTitleBeautyS: "Beauty Studio",
        projectsProjectDescBeautyS: "Strona internetowa salonu kosmetycznego będąca wizytówka firmy, ale także ważnym narzędziem do pozyskiwania klientów. Jest przejrzysta i responsywna oraz prezentuje usługi salonu w sposób atrakcyjny i zachęcający potencjalnych klientów do skorzystania z usług.",

        projectsProjectTitleTatarczuk: "Tatarczuk Usługi",
        projectsProjectDescTatarczuk: "Strona internetowa firmy wykonującej usługi hydrauliczne i serwis kotłów grzewczych. W sposób przejrzysty i harmonijny prezentuje ofertę zakładu. Odzwierciedla profesjonalizm i zaangażowanie w wykonywane usługi, co może zwiększyć zaufanie potencjalnych klientów do firmy.",

        projectsProjectTitleKetoZocha: "KetoZocha Blog",
        projectsProjectDescKetoZocha: "Blog z przepisami w żywieniu ketogenicznym będący cennym źródłem informacji dla osób zainteresowanych takim stylem odżywiania. Strona zawiera nie tylko smaczne i zróżnicowane przepisy, ale również informacje o diecie ketogenicznej i jej korzyściach zdrowotnych oraz artykuły z poradami. Dzięki temu czytelnicy mają dostęp do wartościowych informacji, które pomogą im utrzymać zdrowie i formę.",

        projectsProjectTitleGoPlaces: "Go Places",
        projectsProjectDescGoPlaces: "Aplikacja webowa, której celem jest ułatwienie planowania i porównywania cen w różnych miejscach na świecie. Dzięki intuicyjnemu interfejsowi oraz dodatkowym narzędziom umożliwia szybką analizę oraz porównanie kosztów życia podczas podróży, nawet w najodleglejszych destynacjach. Przydatna każdemu miłośnikowi zwiedzania nowych miejsc, poznawania innych kultur i odkrywania świata!",


        contactFormTitle: "Napisz do mnie!",
        contactFormUserNameInputPlaceholder: "Twoje Imię",
        contactFormUserEmailInputPlaceholder: "Twoj adres email",
        contactFormUserMessageInputPlaceholder: "Twoja wiadomość",
        contactFormSendBtn: "Wyślij",
        contactSentMessageFromPage: "Twoja wiadomość została wysłana!",
        contactNameInvalid: "Podaj prawidłowe dane",
        contactEmailInvalid: "Adres email jest nieprawidłowy",
        contactMessageInvalid: "Twoja wiadomość musi zawierać przynajmniej 5 znaków",

        greetingsStart: "Miłe",
        greetingsDay: ["j Niedzieli", "go Poniedziałku", "go Wtorku", "j Środy", "go Czwartku", "go Piatku", "j Soboty"],
        greetingsEnd: "!",

    }
}